<template>
  <nav class="navbar navbar-static-top">
    <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
      <span class="sr-only">Toggle navigation</span>
    </a>
    <div class="navbar-custom-menu">
      <ul class="nav navbar-nav">
        <li>
          <form class="" style="padding-top: 5px">
            <el-select v-model="appId" placeholder="请选择游戏" filterable @change="changeGame">
              <el-option v-for="item in gameOptions" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
          </form>
        </li>
        <li class="dropdown user user-menu">
          <a href="#" class="dropdown-toggle" data-toggle="dropdown" @click="handleTimeShow()">
            <i class="fa fa-user-circle"></i>
          </a>
          <ul class="dropdown-menu">
            <li class="user-header" style="height: auto">
              <p>你好 <b v-text="username"></b></p>
              <p><small>北京时间 <span v-text="timeNow"></span></small></p>
            </li>
            <li class="user-footer">
              <!--<div class="pull-left">-->
                <!--<a href="javascript:" class="btn btn-default btn-flat">Profile</a>-->
              <!--</div>-->
              <div class="pull-right">
                <a href="javascript:" class="btn btn-default btn-flat" @click="logout()">安全退出</a>
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AltNavbar',
  data () {
    return {
      appId: this.$store.getters.appId,
      timeNow: new Date().toLocaleString()
    }
  },
  created () {
    this.$store.dispatch('GetGames').then(() => {
      //        console.log('created get games', this.$store.getters.games)
      this.appId = this.$store.getters.appId
      this.$store.dispatch('ChangeGame', this.appId).then(() => {
        //          console.log('created game', this.appId, 'channels', this.$store.getters.channels)
      })
    })
  },
  computed: {
    username () {
      return this.$store.getters.user.name
    },
    gameOptions () {
      return this.$store.getters.games
    }
  },
  //    watch: {
  //      appId: function (val, oldVal) {
  //        console.log('nav appId, new:', val, 'old:', oldVal)
  //      }
  //    },
  methods: {
    changeGame () {
      if (!this.appId || this.appId === '') {
        this.$message.error('请选择游戏')
        return
      }
      this.$store.dispatch('ChangeGame', this.appId).then(() => {
        console.log('change game', this.appId)
        console.log('change channels', this.$store.getters.channels)
        this.$router.push({path: '/'})
      })
    },
    handleTimeShow () {
      this.timeNow = new Date().toLocaleString()
    },
    logout () {
      this.$confirm('确认退出吗？', '提示', {type: 'warning'}).then(() => {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 重新实例化vue-router对象 避免bug
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/AltNavbar.vue